import script from "./workSharing.vue?vue&type=script&setup=true&lang=js"
export * from "./workSharing.vue?vue&type=script&setup=true&lang=js"

import "./workSharing.vue?vue&type=style&index=0&id=12b3e70e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b3e70e"]])

export default __exports__